import costPriceHelper, { College, ESTIMATION_METHODS, ESTIMATION_METHOD_LABELS } from 'common/college-price-helper'

type Match = {
  City: string
  State: string
  Control: string
  Setting: string
  Religious: string
  SchoolClassifier?: string
  UnivType?: string
}

const getUnivTypeLabel = (univType?: string) => {
  switch (univType) {
    case '4 year':
      return '4-Year'
    case '2 year':
      return '2-Year'
    case 'Less than 2 year':
      return '< 2-Year'
    default:
      return undefined
  }
}

export const collegeSubtitle = (match: Match, isTnTSearchFilterEnabled = false) => {
  let subTitle = `${match.City}, ${match.State}`
  const univTypeLabel = getUnivTypeLabel(match.UnivType)
  const hasCareerAndTrade = match.SchoolClassifier && match.SchoolClassifier === 'CareerAndTrade'

  if (univTypeLabel && isTnTSearchFilterEnabled) subTitle = subTitle.concat(` • ${univTypeLabel}`)
  if (hasCareerAndTrade && isTnTSearchFilterEnabled) subTitle = subTitle.concat(` • Career & Trade`)
  if (match.Control) subTitle = subTitle.concat(` • ${match.Control}`)
  if (match.Setting && match.Setting !== 'Not available') subTitle = subTitle.concat(` • ${match.Setting}`)
  if (match.Religious && match.Religious !== 'Not applicable') subTitle = subTitle.concat(` • ${match.Religious}`)

  return subTitle
}

export const collegeOverviewData = (college: College) => {
  const undergrads = college.Size || college?.GeneralInfo?.FtDegree3
  const Selectivity = college.Selectivity && college.Selectivity > 0 ? college.Selectivity : 0
  const AcceptanceRate = college.CalculatedFields?.AcceptanceRate || 0
  const acceptance = Math.round(Selectivity || AcceptanceRate || 0)
  const estimationMethod = ESTIMATION_METHODS.averageNetPrice
  const [method, cost] = costPriceHelper.getFormattedCost(estimationMethod, undefined, college)

  const data: { title: string; stat: string | number }[] = []

  if (acceptance) {
    data.push({
      title: 'Admission Rate',
      stat: acceptance > 0 ? `${acceptance}%` : '—',
    })
  }
  if (undergrads) {
    data.push({ title: 'Undergrads', stat: `${undergrads.toLocaleString()}` })
  }
  if (cost) {
    data.push({ title: costPriceHelper.getLabel(method as keyof typeof ESTIMATION_METHOD_LABELS), stat: cost })
  }
  return data
}
